import React, { useState, useContext, useEffect, useRef } from "react";
import {
  AppBar,
  Badge,
  Box,
  Button,
  IconButton,
  Toolbar,
  Typography,
  Drawer,
  List,
  ListItem,
  ListItemText,
  TextField,
  InputAdornment,
  useMediaQuery,
  useTheme,
  Modal,
  CircularProgress,
  Popper,
  Paper,
  ClickAwayListener,
} from "@mui/material";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { headerData } from "../../Data/data";
import { LogoImage, MenuIcon, ShoppingCartIcon, SearchIcon } from "../../Data/image";
import {
  primaryColor,
  secondaryColor,
  navLinksColor,
  navLinksHoverColor,
  iconsColor,
  highlightColor,
  highlightBgColor,
  darkPrimaryColor,
  fontFamilyall,
} from "../../UtilColorPalate/UtilColorPalate";
import Cookies from "js-cookie";
import { LogOutApi, LoginAPI, ProductListAPI } from "../../Utility/UtilApi/UtilApi";
import ProfileModal from "../ProfileModal/ProfileModal";
import ChangePasswordForm from "../ChangePasswordForm/ChangePasswordForm";
import UtilToastMessages from "../../Utility/UtilToastMessages/UtilToastMessages";
import CloseIcon from "@mui/icons-material/Close";
import RegisterPageModal from "../../components/LoginPage/LoginPage";
import ForgotPasswordModal from "../ForgotPasswordModal/ForgotPasswordModal";
import { StoreContext } from "../StoreContext/StoreContext";

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [openProfile, setOpenProfile] = useState(false);
  const [Password, setPassword] = useState(false);
  const [isSnackbarOpen, setSnackbarOpen] = useState(false);
  const [toastmessage, setToastmessage] = useState("");
  const [toastColor, setToastColor] = useState();
  const [username, setUsername] = useState("");
  const [password, setUserPassword] = useState("");
  const [loginModalOpen, setLoginModalOpen] = useState(false);
  const [registerModalOpen, setRegisterModalOpen] = useState(false);
  const [forgotPasswordModalOpen, setForgotPasswordModalOpen] = useState(false);
  const [modalError, setModalError] = useState("");
  const [modalLoading, setModalLoading] = useState(false);
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const searchRef = useRef(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { setIsLoggedIn, isLoggedIn, fetchCurrentDeals, cartCount } = useContext(StoreContext);


  console.log("cartCount",cartCount);
  

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      const response = await ProductListAPI();
      const productList = Array.isArray(response.data.products) ? response.data.products : [];
      setProducts(productList);
    } catch (error) {
      console.error("Error fetching products:", error);
      setToastmessage("Failed to load products for search.");
      setToastColor("error");
      setSnackbarOpen(true);
    }
  };

  useEffect(() => {
    if (searchQuery.trim()) {
      const filtered = products.filter((product) =>
        product.name.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setFilteredProducts(filtered);
      setIsSearchOpen(true);
    } else {
      setFilteredProducts([]);
      setIsSearchOpen(false);
    }
  }, [searchQuery, products]);

  const handleClose = () => setPassword(false);
  const handleSnackbarClick = () => setSnackbarOpen(true);
  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") return;
    setSnackbarOpen(false);
  };
  const handleLogout = () => LogOut();
  const handlePassword = () => setPassword(true);
  const handleProfile = () => setOpenProfile(true);

  function removeAllCookies() {
    const cookies = Cookies.get();
    for (const cookie in cookies) Cookies.remove(cookie);
  }

  const LogOut = async () => {
    try {
      const response = await LogOutApi();
      if (response.statusCode === 201 || response.statusCode === 200) {
        removeAllCookies();
        setIsLoggedIn(false);
        setToastmessage(response.message);
        setToastColor(response.success ? "success" : "error");
        handleSnackbarClick();
        fetchCurrentDeals();
      }
    } catch (err) {
      removeAllCookies();
      setIsLoggedIn(false);
      setToastmessage("Logged out successfully!");
      setToastColor("success");
      handleSnackbarClick();
      console.error("Error:", err);
    }
  };

  const toggleDrawer = (open) => (event) => {
    if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) return;
    setIsDrawerOpen(open);
  };

  const handleSearch = () => {
    if (searchQuery.trim()) navigate(`/shop/${searchQuery}`);
  };

  const handleProductSelect = (product) => {
    setSearchQuery("");
    setIsSearchOpen(false);
    navigate(`/product/${product.id}`, { state: { product } });
    setIsDrawerOpen(false);
  };

  const handleInitialLogin = async () => {
    try {
      const response = await LoginAPI({ username, password });
      if (response.statusCode === 200 || response.statusCode === 201) {
        const expirationTime = new Date(new Date().getTime() + 24 * 3600 * 1000);
        Cookies.set("lkmhbdsfsxasdweioisndi", "nlkjxftvyiukjnkjn", {
          expires: expirationTime,
          secure: false,
          sameSite: "Lax",
        });
        setIsLoggedIn(true);
        setToastmessage(response.message);
        setToastColor("success");
        handleSnackbarClick();
        setUsername("");
        setUserPassword("");
        setTimeout(() => navigate("/home"), 2000);
      } else {
        setModalError("Invalid login credentials. Please try again.");
        setUsername("");
        setUserPassword("");
        setLoginModalOpen(true);
      }
    } catch (error) {
      console.error("Login error:", error);
      setModalError(error.response?.data?.message || "Login failed. Please try again.");
      setUsername("");
      setUserPassword("");
      setLoginModalOpen(true);
    }
  };

  const handleModalLogin = async (e) => {
    e.preventDefault();
    if (!username || !password) {
      setToastmessage("Username and Password are required!");
      setToastColor("error");
      handleSnackbarClick();
      return;
    }
    setModalLoading(true);
    setModalError("");
    try {
      const response = await LoginAPI({ username, password });
      if (response.statusCode === 200 || response.statusCode === 201) {
        const expirationTime = new Date(new Date().getTime() + 24 * 3600 * 1000);
        Cookies.set("lkmhbdsfsxasdweioisndi", "nlkjxftvyiukjnkjn", {
          expires: expirationTime,
          secure: false,
          sameSite: "Lax",
        });
        setIsLoggedIn(true);
        setToastmessage(response.message);
        setToastColor("success");
        handleSnackbarClick();
        setUsername("");
        setUserPassword("");
        setTimeout(() => {
          navigate("/home");
          setLoginModalOpen(false);
        }, 2000);
      } else {
        setModalError("Invalid login credentials. Please try again.");
      }
    } catch (error) {
      console.error("Login error:", error);
      setModalError(error.response?.data?.message || "Login failed. Please try again.");
    } finally {
      setModalLoading(false);
    }
  };

  const handleModalClose = () => {
    setLoginModalOpen(false);
    setModalError("");
    setUsername("");
    setUserPassword("");
  };

  const handleRegisterModalOpen = () => setRegisterModalOpen(true);
  const handleRegisterModalClose = () => setRegisterModalOpen(false);
  const handleForgotPasswordModalOpen = () => setForgotPasswordModalOpen(true);
  const handleForgotPasswordModalClose = () => setForgotPasswordModalOpen(false);

  const handleMenuItemClick = (action) => () => {
    action();
    setIsDrawerOpen(false);
  };

  return (
    <Box sx={{ width: "100%" }}>
      {/* Upper Section - Authentication */}
      <AppBar
        position="fixed"
        sx={{
          top: 0,
          background: "white",
          backdropFilter: "blur(10px)",
          boxShadow: "none",
          padding: "0px",
          zIndex: 1101,
        }}
      >
        <Toolbar sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Link to="/home" style={{ textDecoration: "none", display: "flex", alignItems: "center" }}>
              <img src={LogoImage} alt="megabytes" style={{ width: "60px", marginRight: "10px" }} />
              <Typography
                variant="h5"
                style={{fontFamily: fontFamilyall}}
                sx={{
                  color: primaryColor,
                  fontWeight: "700",
                  letterSpacing: "1px",
                  "&:hover": { color: secondaryColor },
                }}
              >
                {headerData.siteTitle}
              </Typography>
            </Link>
          </Box>

          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            {isMobile ? (
              isLoggedIn ? (
                null
              ) : (
                <Button
                  onClick={() => setLoginModalOpen(true)}
                  sx={{
                    backgroundColor: "#26a69a",
                    color: "#fff",
                    textTransform: "none",
                    padding: "5px 15px",
                    borderRadius: "4px",
                    "&:hover": { backgroundColor: "#2bbbad" },
                    fontFamily: fontFamilyall
                  }}
                 
                >
                  Login
                </Button>
              )
            ) : (
              isLoggedIn ? (
                <>
                  <Button  style={{fontFamily: fontFamilyall}} onClick={handleProfile} sx={{ color: primaryColor, textDecoration: "underline", textTransform: "none", "&:hover": { color: secondaryColor, textDecoration: "underline" } }}>
                    My Profile
                  </Button>
                  <Button  style={{fontFamily: fontFamilyall}} onClick={handlePassword} sx={{ color: primaryColor, textDecoration: "underline", textTransform: "none", "&:hover": { color: secondaryColor, textDecoration: "underline" } }}>
                    Change Password
                  </Button>
                  
                  <Button
                    onClick={handleLogout}
                    sx={{
                      backgroundColor: "rgba(255, 0, 0, 0.5)",
                      color: "#fff",
                      textTransform: "none",
                      padding: "5px 15px",
                      borderRadius: "4px",
                      "&:hover": { backgroundColor: "rgba(255, 0, 0, 0.3)" },
                    }}
                    style={{fontFamily: fontFamilyall}}
                  >
                    Logout
                  </Button>
                </>
              ) : (
                <>
                  <Button  style={{fontFamily: fontFamilyall}} onClick={handleForgotPasswordModalOpen} sx={{ color: primaryColor, textDecoration: "underline", textTransform: "none", "&:hover": { color: secondaryColor, textDecoration: "underline" } }}>
                    Forgot Password
                  </Button>
                  <Button  style={{fontFamily: fontFamilyall}} onClick={handleRegisterModalOpen} sx={{ color: primaryColor, textDecoration: "underline", textTransform: "none", "&:hover": { color: secondaryColor, textDecoration: "underline" } }}>
                    Register
                  </Button>
                  <TextField
         autoComplete="new-password"
                 
                    variant="standard"
                    placeholder="Username"
                    size="small"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    InputProps={{ disableUnderline: true }}
                    style={{fontFamily: fontFamilyall}}
                    sx={{
                      backgroundColor: "#f5f5f5",
                      borderRadius: "4px",
                      padding: "5px 10px",
                      "& .MuiInputBase-input": { padding: "0", fontSize: "14px", color: "#333" },
                    }}
                  />
                  <TextField
         autoComplete="new-password"

                    variant="standard"
                    placeholder="Password"
                    type="password"
                    size="small"
                    value={password}
                    onChange={(e) => setUserPassword(e.target.value)}
                    InputProps={{ disableUnderline: true }}
                    style={{fontFamily: fontFamilyall}}

                    sx={{
                      backgroundColor: "#f5f5f5",
                      borderRadius: "4px",
                      padding: "5px 10px",
                      "& .MuiInputBase-input": { padding: "0", fontSize: "14px", color: "#333" },
                    }}
                  />
                  <Button
                    onClick={handleInitialLogin}
                    sx={{
                      backgroundColor: "#26a69a",
                      color: "#fff",
                      textTransform: "none",
                      padding: "5px 15px",
                      borderRadius: "4px",
                      "&:hover": { backgroundColor: "#2bbbad" },
                    }}
                    style={{fontFamily: fontFamilyall}}
                  >
                    Login
                  </Button>
                </>
              )
            )}
          </Box>
        </Toolbar>
      </AppBar>

      {/* Lower Section - Navigation */}
      <AppBar
  position="fixed"
  sx={{
    top: "60px",
    background: "white",
    backdropFilter: "blur(10px)",
    boxShadow: "none",
    padding: "0px",
    zIndex: 1100,
  }}
>
  <Toolbar sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
    {!isMobile && (
      <Box sx={{ display: "flex", gap: 3 }}>
        {headerData.navLinks.map((link) => (
          <Link key={link.label} to={link.path} style={{ textDecoration: "none", color: navLinksColor }}>
            <Box
              sx={{
                fontFamily: fontFamilyall,
                fontSize: "18px",
                fontWeight: "600",
                textTransform: "capitalize",
                color: location.pathname === link.path ? highlightColor : navLinksColor,
                position: "relative",
                letterSpacing: "0.5px",
                transition: "color 0.3s ease-in-out",
                "&:hover": { color: highlightColor },
                "&::after": {
                  content: '""',
                  position: "absolute",
                  left: 0,
                  bottom: "-4px",
                  width: location.pathname === link.path ? "100%" : "0",
                  height: "2px",
                  backgroundColor: highlightColor,
                  transition: "width 0.3s ease-in-out",
                },
                "&:hover::after": { width: "100%" },
              }}
            >
              {link.label}
            </Box>
          </Link>
        ))}
      </Box>
    )}

    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: isMobile ? "space-between" : "flex-end",
        width: isMobile ? "100%" : "auto",
        gap: 2,
        position: "relative",
      }}
    >
      {isMobile && (
        <IconButton onClick={toggleDrawer(true)} sx={{ color: iconsColor }}>
          <MenuIcon />
        </IconButton>
      )}

      {!isMobile ? (
        <>
          <TextField
            variant="outlined"
            placeholder="Search Product..."
            size="small"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            onFocus={() => searchQuery.trim() && setIsSearchOpen(true)}
            inputRef={searchRef}
            sx={{
              fontFamily: fontFamilyall,
              width: "200px",
              "& .MuiOutlinedInput-root": {
                "& fieldset": { borderColor: "transparent" },
                "&:hover fieldset": { borderColor: primaryColor },
                "&.Mui-focused fieldset": { borderColor: primaryColor },
              },
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={handleSearch}>
                    <SearchIcon sx={{ color: iconsColor }} />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <Popper
            open={isSearchOpen && filteredProducts.length > 0}
            anchorEl={searchRef.current}
            placement="bottom-start"
            sx={{ zIndex: 1200 }}
          >
            <ClickAwayListener onClickAway={() => setIsSearchOpen(false)}>
              <Paper sx={{ maxHeight: "300px", overflowY: "auto", width: "200px", boxShadow: "0 4px 8px rgba(0,0,0,0.1)" }}>
                <List>
                  {filteredProducts.map((product) => (
                    <ListItem
                      button
                      key={product.id}
                      onClick={() => handleProductSelect(product)}
                      sx={{ "&:hover": { backgroundColor: highlightBgColor } }}
                    >
                      <ListItemText primary={product.name} />
                    </ListItem>
                  ))}
                </List>
              </Paper>
            </ClickAwayListener>
          </Popper>
         { isLoggedIn && 
          ( <Link to="/orderhistory">
            <Button sx={{ color: primaryColor, fontFamily: fontFamilyall,textDecoration: "underline", textTransform: "none", "&:hover": { color: secondaryColor } }}>
              Order History
            </Button>
          </Link>

          )}
         
          <Link to="/wishlist">
            <Button sx={{ color: primaryColor,fontFamily: fontFamilyall, textDecoration: "underline", textTransform: "none", "&:hover": { color: secondaryColor } }}>
              Wishlist Items
            </Button>
          </Link>
        </>
      ) : null}

      <Link to="/cart">
        <IconButton sx={{ color: primaryColor }}>
          <Badge badgeContent={cartCount} color="secondary">
            <ShoppingCartIcon sx={{ fontSize: "28px" }} />
          </Badge>
        </IconButton>
      </Link>
    </Box>
  </Toolbar>

  {/* Drawer for Mobile Menu */}
  <Drawer anchor="left" open={isDrawerOpen} onClose={toggleDrawer(false)}>
    <Box sx={{ width: 250, padding: "30px" }}>
      <IconButton onClick={toggleDrawer(false)} sx={{ position: "absolute", right: 8, top: 8 }}>
        <CloseIcon />
      </IconButton>
      <List>
        <ListItem>
          <TextField
            variant="outlined"
            placeholder="Search Product..."
            size="small"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            fullWidth
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={handleSearch}>
                    <SearchIcon sx={{ color: iconsColor }} />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </ListItem>
        {filteredProducts.length > 0 && (
          <ListItem>
            <Box sx={{ maxHeight: "200px", overflowY: "auto", width: "100%" }}>
              <List>
                {filteredProducts.map((product) => (
                  <ListItem
                    button
                    key={product.id}
                    onClick={() => handleProductSelect(product)}
                    sx={{ "&:hover": { backgroundColor: highlightBgColor,  fontFamily: fontFamilyall } }}
                  >
                    <ListItemText primary={product.name} />
                  </ListItem>
                ))}
              </List>
            </Box>
          </ListItem>
        )}

        {headerData.navLinks.map((link) => (
          <ListItem
            button
            key={link.label}
            component={Link}
            to={link.path}
            onClick={() => setIsDrawerOpen(false)}
          >
            <ListItemText primary={link.label} style={{ fontFamily:fontFamilyall}}/>
          </ListItem>
        ))}

        <ListItem
          button
          component={Link}
          to="/orderhistory"
          onClick={() => setIsDrawerOpen(false)}
        >
          <ListItemText primary="Order History" />
        </ListItem>
        <ListItem
          button
          component={Link}
          to="/wishlist"
          onClick={() => setIsDrawerOpen(false)}
        >
          <ListItemText primary="Wishlist Items" />
        </ListItem>

        {!isLoggedIn ? (
          <>
            <ListItem
              button
              onClick={handleMenuItemClick(handleForgotPasswordModalOpen)}
            >
              <ListItemText primary="Forgot Password" />
            </ListItem>
            <ListItem
              button
              onClick={handleMenuItemClick(handleRegisterModalOpen)}
            >
              <ListItemText primary="Register" />
            </ListItem>
            <ListItem
              button
              onClick={handleMenuItemClick(() => setLoginModalOpen(true))}
            >
              <ListItemText primary="Login" />
            </ListItem>
          </>
        ) : (
          <>
            <ListItem
              button
              onClick={handleMenuItemClick(handleProfile)}
            >
              <ListItemText primary="My Profile" />
            </ListItem>
            <ListItem
              button
              onClick={handleMenuItemClick(handlePassword)}
            >
              <ListItemText primary="Change Password" />
            </ListItem>
            <ListItem
              button
              onClick={handleMenuItemClick(handleRegisterModalOpen)}
            >
              <ListItemText primary="Register" />
            </ListItem>
            <ListItem
              button
              onClick={handleMenuItemClick(handleLogout)}
            >
              <ListItemText primary="Logout" />
            </ListItem>
          </>
        )}
      </List>
    </Box>
  </Drawer>
</AppBar>

      {/* Login Modal */}
      <Modal open={loginModalOpen} onClose={handleModalClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            borderRadius: 4,
            boxShadow: 6,
            p: 2,
            outline: "none",
            textAlign: "center",
          }}
        >
          <IconButton
            aria-label="close"
            onClick={handleModalClose}
            sx={{ position: "absolute", right: 8, top: 8, color: "grey.500" }}
          >
            <CloseIcon />
          </IconButton>
          <Typography variant="h5" fontWeight="bold" mb={2} sx={{ color: primaryColor , fontFamily:fontFamilyall}}>
            Login to Your Account
          </Typography>
          <form onSubmit={handleModalLogin}>
            <TextField
              fullWidth
              label="Username"
              name="username"
              placeholder="Enter your username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              margin="normal"
            />
            <TextField
              fullWidth
              label="Password"
              type="password"
              name="password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setUserPassword(e.target.value)}
              margin="normal"
            />
            {modalError && (
              <Typography color="error" sx={{ mb: 2 }}>
                {modalError}
              </Typography>
            )}
            <Button
              type="submit"
              variant="contained"
              fullWidth
              sx={{
                mt: 2,
                py: 1.5,
                borderRadius: 2,
                fontWeight: "bold",
                background: `linear-gradient(135deg, ${primaryColor} 0%, ${darkPrimaryColor} 100%)`,
                "&:hover": { background: `linear-gradient(135deg, ${darkPrimaryColor} 0%, ${primaryColor} 100%)` },
                fontFamily:fontFamilyall
              }}
              disabled={modalLoading}
            >
              {modalLoading ? <CircularProgress size={24} sx={{ color: "white" }} /> : "Login"}
            </Button>
          </form>
        </Box>
      </Modal>

      {/* Register and Forgot Password Modals */}
      <RegisterPageModal open={registerModalOpen} onClose={handleRegisterModalClose} />
      <ForgotPasswordModal
        isOpen={forgotPasswordModalOpen}
        onClose={handleForgotPasswordModalClose}
        setToastmessage={setToastmessage}
        setToastColor={setToastColor}
        handleSnackbarClick={handleSnackbarClick}
      />

      {/* Other Modals and Toast */}
      <ChangePasswordForm
        isOpen={Password}
        onClose={handleClose}
        handleSnackbarClick={handleSnackbarClick}
        setToastmessage={setToastmessage}
        setToastColor={setToastColor}
      />
      <UtilToastMessages
        isOpen={isSnackbarOpen}
        handleClose={handleSnackbarClose}
        data={toastmessage}
        severity={toastColor}
      />
      <ProfileModal open={openProfile} handleClose={() => setOpenProfile(false)} />
    </Box>
  );
};

export default Header;